import React, { useEffect } from "react";
import moment from "moment";
 import { cancelSlotBooking, getBookingDetails } from "../../actions/commonActions"
import { useDispatch } from "react-redux";

const BookingDetail = ({
  className,
  dateFormat,
  dayFormat
  ,eventDate,

  date,
  address,
  showBookingAddress,
   parkingSlotBookingID,
   setLoader
}) => {
  const dispatch = useDispatch();
  const getMonthStartAndEndDates = (inputDate) => {
    const date = new Date(inputDate);
  
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
  
    const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  
    const formatDate = (date) => {
      return date.toISOString().split('T')[0]; 
    };
  
    return {
      startDate: formatDate(startOfMonth),
      endDate: formatDate(endOfMonth),
    };
  };
  
  const  cancelBooking =  () => {
    console.log("parkingSlotBookingID", eventDate)
    setLoader(true);
    const { startDate, endDate } = getMonthStartAndEndDates(date);
    // console.log("parkingSlotBookingIDss", startDate,endDate)

     cancelSlotBooking(dispatch, parkingSlotBookingID,eventDate,setLoader,startDate,endDate); 
   // getBookingDetails(dispatch, eventDate);

  }
  let nowDate = new Date()
  return (
    <div className="jumbotron">
      {
        ["/my_schedule"].includes(window.location.pathname) ? (
          moment(date) >= moment(nowDate) ? (
            <button
              type="button"
              className="cancelPlanBtn"
              onClick={() => cancelBooking()}
            >
              Cancel
            </button>
          ) : ""
        ) : ""
      }
      <h6 className="sub-title">{address.bundle_name}</h6>
      <h6 className="grey-two-color">

        {moment(date).format(dateFormat)},<br />{" "}
        {moment(date).format(dayFormat)}
        <span
          className="no_of_hours"
          style={{ fontWeight: "bold", fontSize: "15px" }}
        >
          {address.end_date_time &&
            address.start_date_time &&
            ` (${moment
              .duration(
                moment(address.end_date_time).diff(
                  moment(address.start_date_time)
                )
              )
              .asHours()} hours)`}
        </span>
      </h6>
      <h3 className="hny-title grey-two-color">
        Parking # <span>{address.visible_number}</span>
      </h3>

      <div className={showBookingAddress ? "" : "d-none"}>
        <p className="street_address">
          <span>{`${address.street_line_1}
            `}</span>
          <span>{` ${address.state ? `${address.state},` : ""} `}</span>
        </p>
      </div>
    </div>
  );
};

export default BookingDetail;